<template>
  <footer>
    <div
      class="columns"
      :class="$route.name === 'Main' ? 'container-fluid' : 'container'"
    >
      <div class="logo" :class="{ hidden: !isBox }">
        <router-link to="/">
          <picture>
            <source
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              srcset="@/assets/i/AFL_logo_RU_blue.svg"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              srcset="@/assets/i/AFL_logo_EN_blue.svg"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              srcset="@/assets/i/AFL_logo_RU_white.png"
              media="(max-width: 767px)"
            />
            <source
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              srcset="@/assets/i/AFL_logo_EN_white.png"
              media="(max-width: 767px)"
            />
            <img
              v-if="$i18n.locale === 'ru' && theme === 'light'"
              src="~@/assets/i/AFL_logo_RU_blue.png"
              alt=""
              class="logo"
              style="width: 218px"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'light'"
              src="~@/assets/i/AFL_logo_EN_blue.png"
              alt=""
              style="width: 218px"
              class="logo"
            />
            <img
              v-else-if="$i18n.locale === 'ru' && theme === 'dark'"
              src="~@/assets/i/AFL_logo_RU_white.png"
              alt=""
              style="width: 218px"
              class="logo"
            />
            <img
              v-else-if="$i18n.locale !== 'ru' && theme === 'dark'"
              src="~@/assets/i/AFL_logo_EN_white.png"
              alt=""
              style="width: 218px"
              class="logo"
            />
          </picture>
        </router-link>
      </div>
      <div class="nav">
        <ul>
          <li :key="index" v-for="(item, index) in items">
            <router-link
              :class="{ active: $route.path.includes(item.id) }"
              :to="{
                name: 'MovieList',
                params: {
                  section: item.id,
                  collection: item.collections[0].id,
                },
              }"
              >{{ item.title }}</router-link
            >
          </li>
          <!-- <li>
            <router-link :to="{ name: 'Favorites' }" active-class="active">{{
              $t("navigation.favorites")
            }}</router-link>
          </li>
          <li v-if="isIfc">
            <a :href="connectLink" class="header">{{
              $t("navigation.connectivity")
            }}</a>
          </li> -->
          <li v-if="isBox">
            <router-link to="/favorites" active-class="selected">
              {{ $t("footer.favorites") }}
            </router-link>
          </li>
          <li>
            <a
              href=""
              active-class="selected"
              @click.prevent="pushRouteSelf('ceo_about_company_')"
            >
              {{ $t("footer.about_company") }}
            </a>
          </li>
          <li>
            <router-link
              :to="{ name: 'FlightInfo' }"
              active-class="selected"
              :class="{ hidden: !flightInfo.number || !isBox }"
            >
              {{ $t("footer.about_fly") }}
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/about" active-class="active">
              {{ $t("footer.about_company") }}
            </router-link>
          </li> -->
          <!-- <li>
            <router-link
              to="/flight-info"
              active-class="active"
              :class="{ hidden: !flightInfo.legs }"
            >
              {{ $t("footer.about_fly") }}
            </router-link>
          </li> -->
          <!-- <li class="opacity-40">
              SkyShop
          </li> -->
          <li>
            <a
              href=""
              active-class="selected"
              @click.prevent="pushRouteSelf('ceo_city_guides_')"
            >
              {{ $t("first-page.guide") }}
            </a>
          </li>
          <li v-if="isBox">
            <router-link to="/help" active-class="selected">
              {{ $t("footer.help") }}
            </router-link>
          </li>
          <!-- <li> -->
          <!-- <router-link to="/bonus" active-class="selected" v-if="isHavePress">
              {{ $t("footer.bonus") }}
            </router-link>  -->
          <!-- <span  class="not-available disabled">{{ -->
          <li v-if="isBox">
            <router-link to="/bonus" active-class="selected" v-if="isHavePress">
              {{ $t("footer.bonus") }}
            </router-link>
            <span v-else class="not-available disabled">{{
              $t("footer.bonus")
            }}</span>
          </li>
          <li v-if="isBox">
            <router-link
              :to="{ name: 'Press' }"
              active-class="selected"
              v-if="isHavePress"
            >
              {{ $t("first-page.press") }}
            </router-link>
            <span v-else class="not-available disabled">{{
              $t("first-page.press")
            }}</span>
          </li>
          <li v-if="!isBox">
            <a
              href=""
              active-class="selected"
              @click.prevent="pushRouteSelf('ceo_announcement_')"
            >
              {{ $t("first-page.upcoming") }}
            </a>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'Services' }" active-class="selected">
              {{ $t("first-page.tile2-1") }}
              {{ $t("first-page.tile2-2") }}
              {{ $t("first-page.tile2-3") }}
            </router-link>
          </li>
         
          <li>
            <router-link :to="{ name: 'UpgradeSeat' }" active-class="selected">
              {{ $t("first-page.tile1-1") }}
              {{ $t("first-page.tile1-2") }}
            </router-link>
          </li> -->
          <!-- <li>
            <router-link :to="{ name: 'Menu' }" active-class="selected">
              {{ $t("first-page.tile3-1") }}
              {{ $t("first-page.tile3-2") }}
            </router-link>
          </li> -->
          <!-- <li>
            <router-link :to="{ name: 'Shop' }" active-class="selected">
              {{ $t("navigation.shop_footer") }}
            </router-link>
          </li> -->
        </ul>
      </div>
      <div class="info">
        <div class="row">
          <div class="col col-24 col-s-10 col-links">
            <router-link class="icon" to="/privacy">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.59375 19.5C14.8405 19.5 19.0938 15.2467 19.0938 10C19.0938 4.75329 14.8405 0.5 9.59375 0.5C4.34704 0.5 0.09375 4.75329 0.09375 10C0.09375 15.2467 4.34704 19.5 9.59375 19.5ZM7.98661 8.25V7.3125C7.98661 6.45312 8.68973 5.75 9.59375 5.75C10.4777 5.75 11.2009 6.45312 11.2009 7.3125V8.25H7.98661ZM6.70089 7.3125V8.25H6.37946C5.65625 8.25 5.09375 8.81641 5.09375 9.5V13.25C5.09375 13.9531 5.65625 14.5 6.37946 14.5H12.808C13.5112 14.5 14.0938 13.9531 14.0938 13.25V9.5C14.0938 8.81641 13.5112 8.25 12.808 8.25H12.4866V7.3125C12.4866 5.76953 11.1808 4.5 9.59375 4.5C7.98661 4.5 6.70089 5.76953 6.70089 7.3125Z"
                  fill="currentColor"
                />
              </svg>
              <!-- <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9.5 19.5C14.7467 19.5 19 15.2467 19 10C19 4.75329 14.7467 0.5 9.5 0.5C4.25329 0.5 0 4.75329 0 10C0 15.2467 4.25329 19.5 9.5 19.5ZM7.89286 8.25V7.3125C7.89286 6.45312 8.59598 5.75 9.5 5.75C10.3839 5.75 11.1071 6.45312 11.1071 7.3125V8.25H7.89286ZM6.60714 7.3125V8.25H6.28571C5.5625 8.25 5 8.81641 5 9.5V13.25C5 13.9531 5.5625 14.5 6.28571 14.5H12.7143C13.4174 14.5 14 13.9531 14 13.25V9.5C14 8.81641 13.4174 8.25 12.7143 8.25H12.3929V7.3125C12.3929 5.76953 11.0871 4.5 9.5 4.5C7.89286 4.5 6.60714 5.76953 6.60714 7.3125Z"
                  fill="currentColor"
                />
              </svg> -->
              <span v-html="$t('footer.privacy')"></span>
            </router-link>
            <router-link class="icon" to="/license">
              <!-- <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 0C4.25 0 0 4.25 0 9.5C0 14.75 4.25 19 9.5 19C14.75 19 19 14.75 19 9.5C19 4.25 14.75 0 9.5 0ZM8.5 13.325C8.175 13.4 7.825 13.425 7.475 13.425C7.05 13.425 6.65 13.35 6.275 13.225C5.9 13.1 5.575 12.875 5.275 12.6C4.975 12.3 4.75 11.925 4.6 11.475C4.425 11 4.35 10.45 4.35 9.775C4.35 9.075 4.45 8.5 4.625 8.05C4.8 7.6 5.075 7.2 5.375 6.925C5.675 6.65 6.025 6.425 6.4 6.325C6.775 6.2 7.15 6.15 7.525 6.15C7.925 6.15 8.275 6.175 8.55 6.225C8.825 6.275 9.05 6.35 9.225 6.425L8.95 7.6C8.8 7.525 8.625 7.475 8.4 7.45C8.2 7.425 7.925 7.4 7.625 7.4C7.075 7.4 6.625 7.6 6.275 8C5.925 8.4 5.775 9 5.775 9.85C5.775 10.2 5.825 10.55 5.9 10.85C5.975 11.15 6.1 11.4 6.275 11.625C6.45 11.825 6.65 12 6.875 12.125C7.125 12.25 7.4 12.3 7.725 12.3C8.025 12.3 8.275 12.275 8.475 12.2C8.675 12.15 8.875 12.075 9.025 11.975L9.3 13.1C9.1 13.15 8.825 13.275 8.5 13.325ZM13.775 13.325C13.45 13.4 13.1 13.425 12.75 13.425C12.325 13.425 11.925 13.35 11.55 13.225C11.175 13.1 10.85 12.875 10.55 12.6C10.25 12.3 10.025 11.925 9.875 11.475C9.7 11 9.625 10.45 9.625 9.775C9.625 9.075 9.725 8.5 9.9 8.05C10.075 7.6 10.35 7.2 10.65 6.925C10.95 6.65 11.3 6.425 11.675 6.325C12.05 6.2 12.425 6.15 12.8 6.15C13.2 6.15 13.55 6.175 13.825 6.225C14.1 6.275 14.325 6.35 14.5 6.425L14.225 7.6C14.075 7.525 13.9 7.475 13.675 7.45C13.475 7.425 13.2 7.4 12.9 7.4C12.35 7.4 11.9 7.6 11.55 8C11.2 8.4 11.05 9 11.05 9.85C11.05 10.2 11.1 10.55 11.175 10.85C11.25 11.15 11.375 11.4 11.55 11.625C11.725 11.825 11.925 12 12.15 12.125C12.4 12.25 12.675 12.3 13 12.3C13.3 12.3 13.55 12.275 13.75 12.2C13.95 12.15 14.15 12.075 14.3 11.975L14.575 13.1C14.375 13.15 14.1 13.275 13.775 13.325Z"
                  fill="currentColor"
                />
              </svg> -->
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.59375 0.5C4.34375 0.5 0.09375 4.75 0.09375 10C0.09375 15.25 4.34375 19.5 9.59375 19.5C14.8438 19.5 19.0938 15.25 19.0938 10C19.0938 4.75 14.8438 0.5 9.59375 0.5ZM8.59375 13.825C8.26875 13.9 7.91875 13.925 7.56875 13.925C7.14375 13.925 6.74375 13.85 6.36875 13.725C5.99375 13.6 5.66875 13.375 5.36875 13.1C5.06875 12.8 4.84375 12.425 4.69375 11.975C4.51875 11.5 4.44375 10.95 4.44375 10.275C4.44375 9.575 4.54375 9 4.71875 8.55C4.89375 8.1 5.16875 7.7 5.46875 7.425C5.76875 7.15 6.11875 6.925 6.49375 6.825C6.86875 6.7 7.24375 6.65 7.61875 6.65C8.01875 6.65 8.36875 6.675 8.64375 6.725C8.91875 6.775 9.14375 6.85 9.31875 6.925L9.04375 8.1C8.89375 8.025 8.71875 7.975 8.49375 7.95C8.29375 7.925 8.01875 7.9 7.71875 7.9C7.16875 7.9 6.71875 8.1 6.36875 8.5C6.01875 8.9 5.86875 9.5 5.86875 10.35C5.86875 10.7 5.91875 11.05 5.99375 11.35C6.06875 11.65 6.19375 11.9 6.36875 12.125C6.54375 12.325 6.74375 12.5 6.96875 12.625C7.21875 12.75 7.49375 12.8 7.81875 12.8C8.11875 12.8 8.36875 12.775 8.56875 12.7C8.76875 12.65 8.96875 12.575 9.11875 12.475L9.39375 13.6C9.19375 13.65 8.91875 13.775 8.59375 13.825ZM13.8687 13.825C13.5437 13.9 13.1938 13.925 12.8438 13.925C12.4187 13.925 12.0188 13.85 11.6438 13.725C11.2688 13.6 10.9438 13.375 10.6438 13.1C10.3438 12.8 10.1187 12.425 9.96875 11.975C9.79375 11.5 9.71875 10.95 9.71875 10.275C9.71875 9.575 9.81875 9 9.99375 8.55C10.1687 8.1 10.4437 7.7 10.7437 7.425C11.0437 7.15 11.3938 6.925 11.7688 6.825C12.1438 6.7 12.5188 6.65 12.8938 6.65C13.2937 6.65 13.6438 6.675 13.9187 6.725C14.1937 6.775 14.4187 6.85 14.5938 6.925L14.3188 8.1C14.1688 8.025 13.9938 7.975 13.7688 7.95C13.5688 7.925 13.2937 7.9 12.9937 7.9C12.4437 7.9 11.9938 8.1 11.6438 8.5C11.2937 8.9 11.1438 9.5 11.1438 10.35C11.1438 10.7 11.1938 11.05 11.2688 11.35C11.3438 11.65 11.4688 11.9 11.6438 12.125C11.8188 12.325 12.0187 12.5 12.2437 12.625C12.4937 12.75 12.7688 12.8 13.0938 12.8C13.3938 12.8 13.6438 12.775 13.8438 12.7C14.0437 12.65 14.2438 12.575 14.3938 12.475L14.6687 13.6C14.4688 13.65 14.1937 13.775 13.8687 13.825Z"
                  fill="currentColor"
                />
              </svg>

              <span v-html="$t('footer.license')"></span>
            </router-link>
          </div>
          <div class="col col-24 col-s-12 offset-s-2 col-button" v-show="isBox">
            <router-link class="button" to="/feedback">{{
              $t("footer.feedback")
            }}</router-link>
          </div>
        </div>
      </div>
      <div class="copyright"></div>
    </div>
  </footer>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import flight from "@/mixins/flight";
import connectLink from "@/mixins/connectLink";
import partners from "@/mixins/partners";
export default {
  name: "FooterCore",
  props: ["items"],
  mixins: [flight, connectLink, partners],
  computed: {
    ...mapState("press", {
      isHavePress: (state) => state.items.length > 0,
    }),
  },
  methods: {
    ...mapMutations({
      setSize: "SET_SIZE",
    }),
    ...mapActions({
      setLocale: "SET_LOCALE",
    }),
  },
};
</script>

<style scoped></style>
